import React from "react";
import { faCloudDownloadAlt, faCloudUploadAlt, faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { useRouter } from "next/navigation";

import { useModal } from "@/hooks/use-modal";

import DropdownMenu, {
  DropdownMenuEntry,
} from "../dropdown-menu/dropdown-menu";
import ChooseAnimationDimensionsModal from "../modal/components/choose-animation-dimensions";
import LoadAnimationModal from "../modal/components/load-animation";
import SaveAnimationModal from "../modal/components/save-animation";

const EditorFileMenu = () => {
  const { openModal } = useModal();
  const router = useRouter();

  const onAnimationToLoadSelected = (animationUrl: string) => {
    router.push(`/editor/${animationUrl}`);
  };

  const menuItems: DropdownMenuEntry[] = [
    {
      icon: faPlusCircle,
      text: "New animation",
      onClick: () => openModal(() => <ChooseAnimationDimensionsModal />),
    },
    {
      icon: faCloudDownloadAlt,
      text: "Load",
      onClick: () =>
        openModal(() => (
          <LoadAnimationModal onSelected={onAnimationToLoadSelected} />
        )),
    },
    {
      icon: faCloudUploadAlt,
      text: "Edit options & save",
      onClick: () => openModal(() => <SaveAnimationModal />),
    },
  ];

  return (
    <DropdownMenu
      align="left"
      button={{
        text: "File",
        type: "transparent",
      }}
      items={menuItems}
    />
  );
};

export default EditorFileMenu;
